"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useSearchInputHeight = function () { return 48; };
exports.default = useSearchInputHeight;
